import unfetch from 'isomorphic-unfetch';

interface Refresh {
  (refToken?: string): Promise<void>;
}

let token: string;
let refresh: Refresh;

export default async function authFetch(
  resource: string,
  init: RequestInit = {},
  tryRefresh = true
): Promise<Response> {
  const headers = Object.assign({}, init.headers, {
    'Content-Type': 'application/json',
  });

  if (typeof token !== 'undefined') {
    headers['Authorization'] = 'Bearer ' + token;
  }

  const request = async (): Promise<ReturnType<typeof unfetch>> =>
    unfetch(resource, { ...init, headers });

  if (!tryRefresh || typeof refresh !== 'function') {
    return request();
  }

  let result = await request();
  if (result.status === 401) {
    try {
      // We could've gotten a 401 because setAccessToken (async) hasn't been called yet, so token was undefined on our
      // first request. Await for refresh(), which will call setAccessToken().
      await refresh();
    } catch (error) {
      return result;
    }
    // EDENG-1489: In case of a successful refresh(), we can update the request headers to include the token.
    if (typeof token !== 'undefined') {
      headers['Authorization'] = 'Bearer ' + token;
    }
    result = await request();
  }
  return result;
}

/**
 * Set the access token to use for making authenticated requests.
 */
export function setAccessToken(t: string): void {
  token = t;
}

/**
 * Unset the current access token used for making authenticated requests.
 */
export function unsetAccessToken(): void {
  token = undefined;
}

/**
 * Set the refresh method to be used when fetch requests fail as Unauthorized.
 */
export function setRefreshMethod(fn: Refresh): void {
  refresh = fn;
}

/**
 * Unset the refresh method, preventing fetch requests from refreshing and retrying.
 */
export function unsetRefreshMethod(): void {
  refresh = undefined;
}
